import { injectGlobal } from 'styled-components'

import { default as VARIABLES } from '../../themes/styles/variables'

injectGlobal`
  /* Thin Scrollbar */
  :root {
    scrollbar-color: ${VARIABLES.COLORS.BLUE_1} ${VARIABLES.COLORS.GRAY_2};
    scrollbar-width: thin;
  }

  html {
    min-height: 100vh;
    background-color: ${VARIABLES.COLORS.GRAY_1};

    /* demo */
    display: flex;
    align-items: stretch;
    width: 100%;
  }

  ::selection {
    background: #eef1ff;
    color: #4b4acb;
  }

  body {
    color: #1f2937;
    font-family: ${VARIABLES.TYPOGRAPHYS.FONT_FAMILIES.FIRST};
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_NORMAL};
    font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.MD};

    display: flex;
    align-items: stretch;
    width: 100%;

    /* demo */
    #root {
      display: flex;
      align-items: stretch;
      width: 100%;
      z-index: 0;
      position: relative;
    }
    /* demo */
    /* zoom: 0.8; */

  }

  .loader {
    border: 4px solid #6c63ff;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }


  .file-download-link {
    text-decoration: underline;
    color: ${VARIABLES.COLORS.BLUE_1};
    margin-bottom: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: ${VARIABLES.COLORS.BLUE_2};
    }
  }

  form {
    width: 100%;
  }

  /* a {
    &.link {
      text-decoration: underline;
      color: ${VARIABLES.COLORS.BLUE_2};
      margin-bottom: 10px;
      cursor: pointer;

      &:hover {
        text-decoration: underline;
        color: ${VARIABLES.COLORS.BLUE_1};
      }
    }
  } */

  .flex-wrap {
    flex-wrap: wrap !important;
  }

  .justify-content-center {
    justify-content: center !important;
  }

  .justify-content-end {
    justify-content: flex-end !important;
  }

  .justify-content-start {
    justify-content: flex-start !important;
  }

  .align-items-center {
    align-items: center !important;
  }

  .align-items-end {
    align-items: flex-end !important;
  }

  .align-items-start {
    align-items: flex-start !important;
  }

  .text-center {
    text-align: center !important;
  }

  .text-left {
    text-align: left !important;
  }

  .text-right {
    text-align: right !important;
  }

  /* for demo */
  /* @media (min-width: 1920px) {
    body {
      zoom: 1;
    }
  }

  @media (max-width: 1680px) {
    body {
      zoom: 0.75;
    }
  }

  @media (max-width: 1440px) {
    body {
      zoom: 0.65;
    }
  }

  @media (max-width: 1280px) {
    body {
      zoom: 0.5;
    }
  } */


  /* bootstrap 3 for summernote plugin */
    kbd {
      padding: 2px 4px;
      font-size: 90%;
      color: #fff;
      background-color: #333;
      border-radius: 3px;
      box-shadow: inset 0 -1px 0 rgba(0, 0, 0, .25);
    }

    // .modal-open {
    //   overflow: hidden;
    //   position: fixed;
    // }
    .modal {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1050;
      display: none;
      overflow: hidden;
      -webkit-overflow-scrolling: touch;
      outline: 0;
    }
    .modal.fade .modal-dialog {
      -webkit-transition: -webkit-transform .3s ease-out;
          -o-transition:      -o-transform .3s ease-out;
              transition:         transform .3s ease-out;
      -webkit-transform: translate(0, -25%);
          -ms-transform: translate(0, -25%);
          -o-transform: translate(0, -25%);
              transform: translate(0, -25%);
    }
    .modal.in .modal-dialog {
      -webkit-transform: translate(0, 0);
          -ms-transform: translate(0, 0);
          -o-transform: translate(0, 0);
              transform: translate(0, 0);
    }
    .modal-open .modal {
      overflow-x: hidden;
      overflow-y: auto;
    }
    .modal-dialog {
      position: relative;
      width: auto;
      margin: 10px;
    }
    .modal-content {
      position: relative;
      background-color: #fff;
      -webkit-background-clip: padding-box;
              background-clip: padding-box;
      border: 1px solid #999;
      border: 1px solid rgba(0, 0, 0, .2);
      border-radius: 6px;
      outline: 0;
      -webkit-box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
              box-shadow: 0 3px 9px rgba(0, 0, 0, .5);
    }
    .modal-backdrop {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1040;
      background-color: #000;
    }
    .modal-backdrop.fade {
      filter: alpha(opacity=0);
      opacity: 0;
    }
    .modal-backdrop.in {
      filter: alpha(opacity=50);
      opacity: .5;
    }
    .modal-header {
      padding: 15px;
      border-bottom: 1px solid #e5e5e5;

      .close {
        float: right;
        font-size: 28px;
        font-weight: bold;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        filter: alpha(opacity=20);
        opacity: .2;
        -webkit-appearance: none;
        padding: 0;
        cursor: pointer;
        background: transparent;
        border: 0;
      }
    }
    .modal-header .close {
      margin-top: -2px;
    }
    .modal-title {
      margin: 0;
      line-height: 1.42857143;
    }
    .modal-body {
      position: relative;
      padding: 15px;

      label {
          display: inline-block;
          max-width: 100%;
          margin-bottom: 5px;
          font-weight: bold;
      }
    }
    .modal-footer {
      padding: 15px;
      text-align: right;
      border-top: 1px solid #e5e5e5;
    }
    .modal-footer .btn + .btn {
      margin-bottom: 0;
      margin-left: 5px;
    }
    .modal-footer .btn-group .btn + .btn {
      margin-left: -1px;
    }
    .modal-footer .btn-block + .btn-block {
      margin-left: 0;
    }
    .modal-scrollbar-measure {
      position: absolute;
      top: -9999px;
      width: 50px;
      height: 50px;
      overflow: scroll;
    }

    @media (min-width: 768px) {
      .modal-dialog {
        width: 600px;
        margin: 30px auto;
      }
      .modal-content {
        -webkit-box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
                box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
      }
      .modal-sm {
        width: 300px;
      }
    }

    @media (min-width: 992px) {
      .modal-lg {
        width: 900px;
      }
    }

    .tooltip {
      position: absolute;
      z-index: 99070;
      display: block;
      font-family: ${VARIABLES.TYPOGRAPHYS.FONT_FAMILIES.FIRST};
      font-size: 12px;
      font-style: normal;
      font-weight: normal;
      line-height: 1.42857143;
      text-align: left;
      text-align: start;
      text-decoration: none;
      text-shadow: none;
      text-transform: none;
      letter-spacing: normal;
      word-break: normal;
      word-spacing: normal;
      word-wrap: normal;
      white-space: normal;
      filter: alpha(opacity=0);
      opacity: 0;

      line-break: auto;
    }

    .tooltip.in {
      filter: alpha(opacity=90);
      opacity: .9;
    }
    .tooltip.top {
      padding: 5px 0;
      margin-top: -3px;
    }
    .tooltip.right {
      padding: 0 5px;
      margin-left: 3px;
    }
    .tooltip.bottom {
      padding: 5px 0;
      margin-top: 3px;
    }
    .tooltip.left {
      padding: 0 5px;
      margin-left: -3px;
    }
    .tooltip-inner {
      max-width: 200px;
      padding: 3px 8px;
      color: #fff;
      text-align: center;
      background-color: #000;
      border-radius: 4px;
    }
    .tooltip-arrow {
      position: absolute;
      width: 0;
      height: 0;
      border-color: transparent;
      border-style: solid;
    }
    .tooltip.top .tooltip-arrow {
      bottom: 0;
      left: 50%;
      margin-left: -5px;
      border-width: 5px 5px 0;
      border-top-color: #000;
    }
    .tooltip.top-left .tooltip-arrow {
      right: 5px;
      bottom: 0;
      margin-bottom: -5px;
      border-width: 5px 5px 0;
      border-top-color: #000;
    }
    .tooltip.top-right .tooltip-arrow {
      bottom: 0;
      left: 5px;
      margin-bottom: -5px;
      border-width: 5px 5px 0;
      border-top-color: #000;
    }
    .tooltip.right .tooltip-arrow {
      top: 50%;
      left: 0;
      margin-top: -5px;
      border-width: 5px 5px 5px 0;
      border-right-color: #000;
    }
    .tooltip.left .tooltip-arrow {
      top: 50%;
      right: 0;
      margin-top: -5px;
      border-width: 5px 0 5px 5px;
      border-left-color: #000;
    }
    .tooltip.bottom .tooltip-arrow {
      top: 0;
      left: 50%;
      margin-left: -5px;
      border-width: 0 5px 5px;
      border-bottom-color: #000;
    }
    .tooltip.bottom-left .tooltip-arrow {
      top: 0;
      right: 5px;
      margin-top: -5px;
      border-width: 0 5px 5px;
      border-bottom-color: #000;
    }
    .tooltip.bottom-right .tooltip-arrow {
      top: 0;
      left: 5px;
      margin-top: -5px;
      border-width: 0 5px 5px;
      border-bottom-color: #000;
    }
  /* bootstrap 3 for summernote plugin */


  /* React Tooltip */
  .__react_component_tooltip {
    &.basic-white {
      color: ${VARIABLES.COLORS.GRAY_3};
      background-color: white;
      border: 1px solid ${VARIABLES.COLORS.GRAY_2};
    }
  }

  .select__menu {
    .select__menu-list {
      color: ${VARIABLES.COLORS.BLUE_1};

      .group-head {
      }

      .group-option {
        padding-left: 40px;
      }
    }
  }

  @media all and (max-width: 1600.98px) {
    body {
      font-size: 16px;
    }
  }

  @media all and (max-width: 1440.98px) {
    body {
      font-size: 15px;
    }
  }

  @media all and (max-width: 1366.98px) {
    body {
      font-size: 14px;
    }
  }

  @media all and (max-width: 1280.98px) {
    body {
      font-size: 13px;
    }
  }

  @media all and (max-width: 1024.98px) {
    body {
      font-size: 12px;
    }
  }
`
